"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// All of the variations on 'type' that a Grade Result may take.
exports.default = {
    // NCEA.
    NCEA_NOT_ACHIEVED_CREDITS: 'NCEA/notAchievedCredits',
    NCEA_ACHIEVED_CREDITS: 'NCEA/achievedCredits',
    NCEA_MERIT_CREDITS: 'NCEA/meritCredits',
    NCEA_EXCELLENCE_CREDITS: 'NCEA/excellenceCredits',
    NCEA_NOT_ACHIEVED_CREDITS_EXTERNAL: 'NCEA/notAchievedCreditsExternal',
    NCEA_ACHIEVED_CREDITS_EXTERNAL: 'NCEA/achievedCreditsExternal',
    NCEA_MERIT_CREDITS_EXTERNAL: 'NCEA/meritCreditsExternal',
    NCEA_EXCELLENCE_CREDITS_EXTERNAL: 'NCEA/excellenceCreditsExternal',
    NCEA_SUBJECT_ENDORSEMENT: 'NCEA/subjectEndorsement',
    NCEA_LEVEL_1_ENDORSEMENT: 'NCEA/level1Endorsement',
    NCEA_LEVEL_2_ENDORSEMENT: 'NCEA/level2Endorsement',
    NCEA_LEVEL_3_ENDORSEMENT: 'NCEA/level3Endorsement',
    NCEA_TOTAL_CREDITS: 'NCEA/totalCredits',
    NCEA_TOTAL_CREDITS_EXTERNAL: 'NCEA/totalCreditsExternal',
    // IB.
    IB_PREDICTED_GRADE: 'IB/predictedGrade',
    IB_ACHIEVED_GRADE: 'IB/achievedGrade',
    IB_TOK_PREDICTED_GRADE: 'IB/TOK/predictedGrade',
    IB_TOK_ACHIEVED_GRADE: 'IB/TOK/achievedGrade',
    IB_EE_PREDICTED_GRADE: 'IB/EE/predictedGrade',
    IB_EE_ACHIEVED_GRADE: 'IB/EE/achievedGrade',
    IB_CAS_PREDICTED_GRADE: 'IB/CAS/predictedGrade',
    IB_CAS_ACHIEVED_GRADE: 'IB/CAS/achievedGrade',
    IB_EE_TOK: 'IB/EE_TOK',
    IB_TOTAL_POINTS: 'IB/totalPoints',
    IB_RESULTS: 'IB/results',
    // CIE.
    CIE_SCHOOL_EXAM_PERCENTAGE: 'CIE/schoolExamPercentage',
    CIE_SCHOOL_EXAM_GRADE: 'CIE/schoolExamGrade',
    CIE_FINAL_EXAM_PERCENTAGE: 'CIE/finalExamPercentage',
    CIE_FINAL_EXAM_GRADE: 'CIE/finalExamGrade',
    CIE_AWARDS: 'CIE/awards',
    CIE_AGGREGATE_SCORE: 'CIE/aggregateScore',
    // HSC.
    HSC_EXAMINATION_MARK: 'HSC/examinationMark',
    HSC_ASSESSMENT_MARK: 'HSC/assessmentMark',
    HSC_MARK: 'HSC/mark',
    HSC_PERFORMANCE_BAND: 'HSC/performanceBand',
    HSC_ATAR: 'HSC/ATAR',
    // VCE.
    VCE_GA1: 'VCE/ga1',
    VCE_GA2: 'VCE/ga2',
    VCE_GA3: 'VCE/ga3',
    VCE_STUDY_SCORE: 'VCE/studyScore',
    VCE_SCALED_SCORE: 'VCE/scaledScore',
    VCE_AGGREGATE: 'VCE/aggregate',
    VCE_ATAR: 'VCE/ATAR',
    // NZQA.
    NZQA_AWARDS: 'NZQA/awards',
    NZQA_SCORE: 'NZQA/score',
    NZQA_OVERALL_AWARDS: 'NZQA/overallAwards',
    // SAT Reasoning.
    SAT_REASONING_READING_WRITING: 'SAT-REASONING/readingWriting',
    SAT_REASONING_MATH: 'SAT-REASONING/math',
    SAT_REASONING_ESSAY: 'SAT-REASONING/essay',
    SAT_REASONING_OVERALL_SCORE: 'SAT-REASONING/overallScore',
    // SAT Subject.
    SAT_SUBJECT_SCORE: 'SAT-SUBJECT/score',
    // ACT.
    ACT_MATH: 'ACT/math',
    ACT_SCIENCE: 'ACT/science',
    ACT_READING: 'ACT/reading',
    ACT_ENGLISH: 'ACT/english',
    ACT_WRITING: 'ACT/writing',
    ACT_OVERALL_SCORE: 'ACT/overallScore',
    // AP.
    AP_SCORE: 'AP/score',
    // IELTS
    IELTS_TEST_TYPE: 'IELTS/testType',
    IELTS_LISTENING: 'IELTS/listening',
    IELTS_READING: 'IELTS/reading',
    IELTS_WRITING: 'IELTS/writing',
    IELTS_SPEAKING: 'IELTS/speaking',
    IELTS_OVERALL: 'IELTS/overall',
    // TOEFL
    TOEFL_LISTENING: 'TOEFL/listening',
    TOEFL_READING: 'TOEFL/reading',
    TOEFL_WRITING: 'TOEFL/writing',
    TOEFL_SPEAKING: 'TOEFL/speaking',
    TOEFL_OVERALL: 'TOEFL/overall',
    // UCAT
    UCAT_VR_SCORE: 'UCAT/vrScore',
    UCAT_DM_SCORE: 'UCAT/dmScore',
    UCAT_QR_SCORE: 'UCAT/qrScore',
    UCAT_AR_SCORE: 'UCAT/arScore',
    UCAT_TOTAL_COGNITIVE_SUBTEST_SCORE: 'UCAT/totalCognitiveSubtestScore',
    UCAT_SJT_SCORE: 'UCAT/sjtScore',
    UCAT_PERCENTILE: 'UCAT/percentile',
    // GAMSAT
    GAMSAT_SECTION_I_SCORE: 'GAMSAT/sectionIScore',
    GAMSAT_SECTION_II_SCORE: 'GAMSAT/sectionIIScore',
    GAMSAT_SECTION_III_SCORE: 'GAMSAT/sectionIIIScore',
    GAMSAT_OVERALL_SCORE: 'GAMSAT/overallScore',
    GAMSAT_PERCENTILE: 'GAMSAT/percentile',
    // QCE
    QCE_IA_1_NUMERICAL_SCORE: 'QCE/ia1NumericalScore',
    QCE_IA_1_GRADE: 'QCE/ia1Grade',
    QCE_IA_2_NUMERICAL_SCORE: 'QCE/ia2NumericalScore',
    QCE_IA_2_GRADE: 'QCE/ia2Grade',
    QCE_IA_3_NUMERICAL_SCORE: 'QCE/ia3NumericalScore',
    QCE_IA_3_GRADE: 'QCE/ia3Grade',
    QCE_EA_1_NUMERICAL_SCORE: 'QCE/ea1NumericalScore',
    QCE_EA_1_GRADE: 'QCE/ea1Grade',
    QCE_OVERALL_NUMERICAL_SCORE: 'QCE/overallNumericalScore',
    QCE_OVERALL_GRADE: 'QCE/overallGrade',
    // WACE
    WACE_SCHOOL_MARK_NUMERICAL: 'WACE/schoolMarkNumerical',
    WACE_SCHOOL_MARK_GRADE: 'WACE/schoolMarkGrade',
    WACE_EXAM_MARK_NUMERICAL: 'WACE/examMarkNumerical',
    WACE_EXAM_GRADE: 'WACE/examGrade',
    WACE_COMBINED_SCORE: 'WACE/combinedScore',
    // SACE
    SACE_IA_GRADE: 'SACE/iaGrade',
    SACE_EA_GRADE: 'SACE/eaGrade',
    SACE_FINAL_GRADE: 'SACE/finalGrade',
    // CELS191
    CELS191_PROGRESS_TEST_MARK: 'CELS191/progressTestMark',
    CELS191_FINAL_MARK: 'CELS191/finalMark',
    // CHEM191
    CHEM191_PROGRESS_TEST_MARK: 'CHEM191/progressTestMark',
    CHEM191_FINAL_MARK: 'CHEM191/finalMark',
    // PHSI191
    PHSI191_PROGRESS_TEST_MARK: 'PHSI191/progressTestMark',
    PHSI191_FINAL_MARK: 'PHSI191/finalMark',
    // BIOC192
    BIOC192_PROGRESS_TEST_MARK: 'BIOC192/progressTestMark',
    BIOC192_FINAL_MARK: 'BIOC192/finalMark',
    // HUBS191
    HUBS191_PROGRESS_TEST_1_MARK: 'HUBS191/progressTest1Mark',
    HUBS191_PROGRESS_TEST_2_MARK: 'HUBS191/progressTest2Mark',
    HUBS191_FINAL_MARK: 'HUBS191/finalMark',
    // HUBS192
    HUBS192_PROGRESS_TEST_1_MARK: 'HUBS192/progressTest1Mark',
    HUBS192_PROGRESS_TEST_2_MARK: 'HUBS192/progressTest2Mark',
    HUBS192_FINAL_MARK: 'HUBS192/finalMark',
    // POPH192
    POPH192_PROGRESS_TEST_1_MARK: 'POPH192/progressTest1Mark',
    POPH192_PROGRESS_TEST_2_MARK: 'POPH192/progressTest2Mark',
    POPH192_FINAL_MARK: 'POPH192/finalMark',
    // Optional 8th Paper
    OPTIONAL_8TH_PAPER_FINAL_MARK: 'OPTIONAL_8TH_PAPER/finalMark',
    // ISAT
    ISAT_CR_SCORE: 'ISAT/crScore',
    ISAT_QR_SCORE: 'ISAT/qrScore',
    ISAT_TOTAL_SCORE: 'ISAT/totalScore',
    ISAT_PERCENTILE: 'ISAT/percentile',
    // BMAT
    BMAT_SECTION_1: 'BMAT/section1',
    BMAT_SECTION_2: 'BMAT/section2',
    BMAT_SECTION_3: 'BMAT/section3',
    // BIOSCI107
    BIOSCI107_TEST_GRADE: 'BIOSCI107/testGrade',
    BIOSCI107_FINAL_GRADE: 'BIOSCI107/finalGrade',
    // CHEM110
    CHEM110_TEST_GRADE: 'CHEM110/testGrade',
    CHEM110_FINAL_GRADE: 'CHEM110/finalGrade',
    // POPLHLTH111
    POPLHLTH111_TEST_GRADE: 'POPLHLTH111/testGrade',
    POPLHLTH111_FINAL_GRADE: 'POPLHLTH111/finalGrade',
    // MEDSCI142
    MEDSCI142_TEST_1_GRADE: 'MEDSCI142/test1Grade',
    MEDSCI142_TEST_2_GRADE: 'MEDSCI142/test2Grade',
    MEDSCI142_FINAL_GRADE: 'MEDSCI142/finalGrade',
    // ATAR
    ATAR: 'ATAR/atar',
    // Auckland Core CPA Paper Overall GPA
    AKL_CCP_OVERALL_GPA: 'AKLCCP/overallGPA',
    // Otago Paper Average (Best 7)
    OTAGO_P_AVG_BEST_7_AVERAGE: 'OTAGO_P_AVG_BEST_7/average',
    // School GPA.
    SCHOOL_GPA: 'SCHOOL_GPA/score',
    GPA_REGION: 'SCHOOL_GPA/region',
    GPA_YEAR: 'SCHOOL_GPA/year',
    // TOEFL PBT
    TOEFL_PBT_OVERALL: 'TOEFL_PBT/overall',
    // Practice SAT
    PRACTICE_SAT_READING_WRITING: 'PRACTICE_SAT/readingWriting',
    PRACTICE_SAT_MATH: 'PRACTICE_SAT/math',
    PRACTICE_SAT_ESSAY: 'PRACTICE_SAT/essay',
    PRACTICE_SAT_OVERALL_SCORE: 'PRACTICE_SAT/overallScore',
    // Practice ACT.
    PRACTICE_ACT_MATH: 'PRACTICE_ACT/math',
    PRACTICE_ACT_SCIENCE: 'PRACTICE_ACT/science',
    PRACTICE_ACT_READING: 'PRACTICE_ACT/reading',
    PRACTICE_ACT_ENGLISH: 'PRACTICE_ACT/english',
    PRACTICE_ACT_WRITING: 'PRACTICE_ACT/writing',
    PRACTICE_ACT_OVERALL_SCORE: 'PRACTICE_ACT/overallScore',
    // Duolingo
    Duolingo: 'Duolingo/score',
    // TSA
    TSA_SECTION_1: 'TSA/section1',
    // SSAT
    SSAT_VERBAL: 'SSAT/verbal',
    SSAT_QUANTITATIVE: 'SSAT/quantitative',
    SSAT_READING: 'SSAT/reading',
    SSAT_TOTAL: 'SSAT/total',
    // ISEE
    ISEE_VERBAL_REASONING: 'ISEE/verbalReasoning',
    ISEE_READING_COMPREHENSION: 'ISEE/readingComprehension',
    ISEE_QUANTITATIVE_REASONING: 'ISEE/quantitativeReasoning',
    ISEE_MATH: 'ISEE/math',
    // PTE
    PTE_LISTENING: 'PTE/listening',
    PTE_SPEAKING: 'PTE/speaking',
    PTE_WRITING: 'PTE/writing',
    PTE_READING: 'PTE/reading',
    PTE_OVERALL: 'PTE/overall',
    // GMAT
    GMAT_VERBAL: 'GMAT/verbal',
    GMAT_REASONING: 'GMAT/reasoning',
    GMAT_QUANTITATIVE: 'GMAT/quantitative',
    GMAT_WRITING: 'GMAT/writing',
    GMAT_TOTAL: 'GMAT/total',
    // GRE
    GRE_VERBAL_REASONING: 'GRE/verbalReasoning',
    GRE_QUANTITATIVE_REASONING: 'GRE/quantitativeReasoning',
    GRE_ANALYTICAL_WRITING: 'GRE/analyticalWriting',
    GRE_TOTAL: 'GRE/total',
    // LSAT
    LSAT_SCORE: 'LSAT/score',
    LSAT_PERCENTILE: 'LSAT/percentile',
    // MCAT
    MCAT_CHEMICAL_AND_PHYSICAL_FOUNDATIONS: 'MCAT/chemicalAndPhysicalFoundations',
    MCAT_BIOLOGICAL_AND_BIOCHEMICAL_FOUNDATIONS: 'MCAT/biologicalAndBiochemicalFoundations',
    MCAT_PHYSIOGILOGICAL_FOUNDATIONS: 'MCAT/physiogilogicalFoundations',
    MCAT_CRITICAL_ANALYSIS_AND_REASONING_SKILLS: 'MCAT/criticalAnalysisAndReasoningSkills',
    MCAT_TOTAL: 'MCAT/total',
    // LNAT
    LNAT_SECTION_A: 'LNAT/sectionA',
    // MAT
    MAT_Q1: 'MAT/q1',
    MAT_Q2_Q7: 'MAT/q2q7',
    MAT_TOTAL: 'MAT/total',
    // TMUA
    TMUA_PAPER_1: 'TMUA/paper1',
    TMUA_PAPER_2: 'TMUA/paper2',
    TMUA_TOTAL: 'TMUA/total',
    // NSAA
    NSAA_SECTION_A: 'NSAA/sectionA',
    NSAA_SECTION_B: 'NSAA/sectionB',
    NSAA_TOTAL: 'NSAA/total',
    // ENGAA
    ENGAA_SECTION_1A: 'ENGAA/section1a',
    ENGAA_SECTION_1B: 'ENGAA/section1b',
    ENGAA_SECTION_2: 'ENGAA/section2',
    // STEP
    STEP_MATH_II: 'STEP/mathII',
    STEP_MATH_III: 'STEP/mathIII',
    // HPAT
    HPAT_LOGICAL: 'HPAT/logical',
    HPAT_INTERPERSONAL: 'HPAT/interpersonal',
    HPAT_NON_VERBAL: 'HPAT/nonVerbal',
    HPAT_TOTAL: 'HPAT/total',
    // PAT
    PAT_TOTAL: 'PAT/total',
    // ELAT
    ELAT_TOTAL: 'ELAT_TOTAL/total',
    // HAT
    HAT_TOTAL: 'HAT_TOTAL/total',
    // CAT
    CAT_TOTAL: 'CAT_TOTAL/total',
    // OLAT
    OLAT_TOTAL: 'OLAT_TOTAL/total',
    // MLAT
    MLAT_TOTAL: 'MLAT_TOTAL/total',
    // PHIL
    PHIL_TOTAL: 'PHIL_TOTAL/total',
    // IMAT
    IMAT_TOTAL: 'IMAT_TOTAL/total',
    // Bocconi
    BOCCONI_TOTAL: 'BOCCONI_TOTAL/total',
    // Technical University of Munich Admission Test
    TUMAT_TOTAL: 'TUMAT_TOTAL/total',
    // PSAT
    PSAT_READING_WRITING: 'PSAT/readingWriting',
    PSAT_MATH: 'PSAT/math',
    PSAT_OVERALL_SCORE: 'PSAT/overallScore',
    // UK_ISAT
    UK_ISAT_CR_SCORE: 'UK_ISAT/crScore',
    UK_ISAT_QR_SCORE: 'UK_ISAT/qrScore',
    UK_ISAT_TOTAL_SCORE: 'UK_ISAT/totalScore',
    UK_ISAT_PERCENTILE: 'UK_ISAT/percentile',
    UK_ISAT_CR_PERCENTILE: 'UK_ISAT/crPercentile',
    UK_ISAT_QR_PERCENTILE: 'UK_ISAT/qrPercentile',
    // Bellow are EU Testings
    EU_PCE_TOTAL: 'EU_PCE_TOTAL/total',
    EU_PCE_COMBINED: 'EU_PCE_TOTAL/combined',
    EU_PCE_COMBINED_SECONDARY_CERTIFICATE_TOTAL: 'EU_PCE_COMBINED_SECONDARY_CERTIFICATE/total',
    EU_OMPT_A: 'EU_OMPT_A/total',
    EU_OMPT_B: 'EU_OMPT_B/total',
    EU_OMPT_C: 'EU_OMPT_C/total',
    EU_OMPT_D: 'EU_OMPT_D/total',
    EU_VWO_PHYSICS: 'EU_VWO/physics',
    EU_VWO_CHEMISTRY: 'EU_VWO/chemistry',
    EU_VWO_MATH_A: 'EU_VWO/mathA',
    EU_VWO_MATH_B: 'EU_VWO/mathB',
    EU_VWO_MATH_C: 'EU_VWO/mathC',
    EU_VWO_BIOLOGY: 'EU_VWO/biology',
    EU_HUMAT: 'EU_HUMAT/total',
    EU_UCAT_CAMILLUS_VR_SCORE: 'EU_UCAT_CAMILLUS/vrScore',
    EU_UCAT_CAMILLUS_DM_SCORE: 'EU_UCAT_CAMILLUS/dmScore',
    EU_UCAT_CAMILLUS_QR_SCORE: 'EU_UCAT_CAMILLUS/qrScore',
    EU_UCAT_CAMILLUS_AR_SCORE: 'EU_UCAT_CAMILLUS/arScore',
    EU_UCAT_CAMILLUS_SJ_SCORE: 'EU_UCAT_CAMILLUS/sjScore',
    EU_UCAT_CAMILLUS_TOTAL: 'EU_UCAT_CAMILLUS/total',
    EU_IE_UNIVERSITY_ADMISSIONS: 'EU_IE_UNIVERSITY_ADMISSIONS/total',
    EU_ARCHITECTURE_ADMISSIONS: 'EU_ARCHITECTURE_ADMISSIONS/total',
    EU_ETH_ZURICH: 'EU_ETH_ZURICH/total',
    EU_EHL_ADMISSIONS: 'EU_ADMISSIONS/total',
    EU_CCVX_BIOLOGY: 'EU_CCVX_BIOLOGY/total',
    EU_CCVX_PHYSICS: 'EU_CCVX_PHYSICS/total',
    EU_CCVX_CHEMISTRY: 'EU_CCVX_CHEMISTRY/total',
    EU_CCVX_MATH_A: 'EU_CCVX_CHEMISTRY/total',
    EU_CCVX_MATH_B: 'EU_CCVX_CHEMISTRY/total',
    EU_BOCCONI_ONLINE: 'EU_BOCCONI_ONLINE/total',
    EU_ENLIGSH_TOLC_I: 'EU_ENLIGSH_TOLC_I/total',
    EU_ENLIGSH_TOLC_E: 'EU_ENLIGSH_TOLC_E/total',
    EU_ENLIGSH_TOLC_F: 'EU_ENLIGSH_TOLC_F/total',
    EU_STUDIENKOLLEG: 'EU_STUDIENKOLLEG/total',
    EU_EBAU: 'EU_EBAU/total',
    EU_EBAU_COMBINED: 'EU_EBAU/combined',
    EU_EBAU_COMBINED_SECONDARY_CERTIFICATE_TOTAL: 'EU_EBAU_COMBINED_SECONDARY_CERTIFICATE/total',
    // Bellow are  extra UK Testings
    ARCHAEOLOGY_ADMIS_ASSESS: 'ARCHAEOLOGY_ADMIS_ASSESS',
    ARCH_ADMIS_ASSESS_total: 'ARCH_ADMIS_ASSESS/total',
    ARCH_ADMIS_ASSESS_1: 'ARCH_ADMIS_ASSESS/part1',
    ARCH_ADMIS_ASSESS_2: 'ARCH_ADMIS_ASSESS/part2',
    MOD_MED_LANG_ADMIS_ASSESS_total: 'MOD_MED_LANG_ADMIS_ASSESS/total',
    MOD_MED_LANG_ADMIS_ASSESS_A: 'MOD_MED_LANG_ADMIS_ASSESS/sectionA',
    MOD_MED_LANG_ADMIS_ASSESS_B: 'MOD_MED_LANG_ADMIS_ASSESS/sectionB',
    ENGL_ADMIS_ASSESS: 'ENGL_ADMIS_ASSESS/total',
    GEOG_ADMIS_ASSESS: 'GEOG_ADMIS_ASSESS/total',
    HIST_ADMIS_ASSESS: 'HIST_ADMIS_ASSESS:/total',
    HIST_ART_ADMIS_ASSESS: 'HIST_ART_ADMIS_ASSESS/total',
    HIST_SOC_POL_SCI_ADMIS_ASSESS: 'HIST_SOC_POL_SCI_ADMIS_ASSESS/total',
    LING_ADMIS_ASSESS_total: 'LING_ADMIS_ASSESS/total',
    LING_ADMIS_ASSESS_1: 'LING_ADMIS_ASSESS/part1',
    LING_ADMIS_ASSESS_2: 'LING_ADMIS_ASSESS/part2',
    LING_ADMIS_ASSESS_3: 'LING_ADMIS_ASSESS/part3',
    MATH_ADMIS_ASSESS: 'MATH_ADMIS_ASSESS/total',
    MUS_ADMIS_ASSESS: 'MUS_ADMIS_ASSESS/total',
    PHIL_ADMIS_ASSESS_total: 'PHIL_ADMIS_ASSESS/total',
    PHIL_ADMIS_ASSESS_1: 'PHIL_ADMIS_ASSESS/part1',
    PHIL_ADMIS_ASSESS_2: 'PHIL_ADMIS_ASSESS/part2',
    PSYCH_ADMIS_ASSESS: 'PSYCH_ADMIS_ASSESS/total',
    // AHCAAT
    AHCAAT_TOTAL: 'AHCAAT/total',
    // BSMAT
    BSMAT_TOTAL: 'BSMAT/total',
    // ENEM
    ENEM_LANGUAGE: 'ENEM/language',
    ENEM_MATHEMATICS: 'ENEM/mathematics',
    ENEM_NATURAL_SCIENCES: 'ENEM/naturalSciences',
    ENEM_WRITING: 'ENEM/writing',
    ENEM_HUMANITIES: 'ENEM/humanities',
    ENEM_TOTAL: 'ENEM/total',
    // ARCHITECTURE_TIL_TEST
    ARCHITECTURE_TIL_TEST_SECTION_1: 'ARCHITECTURE_TIL_TEST/section1',
    ARCHITECTURE_TIL_TEST_SECTION_2: 'ARCHITECTURE_TIL_TEST/section2',
    ARCHITECTURE_TIL_TEST_SECTION_3: 'ARCHITECTURE_TIL_TEST/section3',
    ARCHITECTURE_TIL_TEST_SECTION_4: 'ARCHITECTURE_TIL_TEST/section4',
    ARCHITECTURE_TIL_TEST_SECTION_5: 'ARCHITECTURE_TIL_TEST/section5',
    ARCHITECTURE_TIL_TEST_TOTAL: 'ARCHITECTURE_TIL_TEST/total',
};
//# sourceMappingURL=gradeResultType.js.map